const initialState = {
    datasets:[],
    modalDataset: false,
    modalUpload: false,
    modalApprove: false,
    modalViewDataset: false,
    formDataset: {
        Id:null,
        MetadataId:null
    }

}

const datasetReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'DATASETS':
            return { ...state, datasets: action.payload }
        case 'MODAL_DATASET':
            return { ...state, modalDataset: action.payload }
        case 'MODAL_UPLOAD':
            return { ...state, modalUpload: action.payload }
        case 'MODAL_APPROVE':
            return { ...state, modalApprove: action.payload }
        case 'MODAL_VIEW_DATASET':
            return { ...state, modalViewDataset: action.payload }
        case 'RESET_FORM_DATASET':
            return { ...state, formDataset: initialState.formDataset }
        case 'FORM_DATASET':
            return {
                ...state,
                formDataset: {
                    ...state.formDataset,
                    [action.formType]: action.formValue
                }
            }
        default:
            return state
    }
}

export default datasetReducer;